export default __webpack_public_path__ + "5b07341625e2655384b95000b9ed0900.png";